// extracted by mini-css-extract-plugin
export default {"tabContent":"TabPanel_tabContent__XXK9k","scrollable":"TabPanel_scrollable__UpMf7","invisible":"TabPanel_invisible__U1Q-J"};